<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="12">
          <a-col :span="10">
            <a-form-item label="Repayment Time">
              <a-range-picker
                v-model="queryParam.dataDt"
                format="YYYY-MM-DD"
                style="width: 100%;"/>
            </a-form-item>
          </a-col>

          <a-col :span="4">
            <a-form-item label="Status" style="margin-left: 10px">
              <a-select v-model="queryParam.status" >
                <a-select-option :key='""'>
                  All
                </a-select-option>
                <a-select-option :key='"00"'>
                  Pending
                </a-select-option>
                <a-select-option :key='"01"'>
                  No Action Needed
                </a-select-option>
                <a-select-option :key='"02"'>
                  Pending Refund
                </a-select-option>
                <a-select-option :key='"03"'>
                  Refunding
                </a-select-option>
                <a-select-option :key='"04"'>
                  Pending Reduction
                </a-select-option>
                <a-select-option :key='"05"'>
                  Processed
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="Order No." style="margin-left: 10px">
              <a-input v-model="queryParam.orderNo" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="downLoadData()" icon="download"
                        style="margin-left: 8px">Export File
                              </a-button>
            </span>
          </a-col>

        </a-row>
        <a-row :gutter="12">
          <a-col :span="5">
            <a-form-item label="Batch Volume Action">
              <a-select
                v-model="saveStatus"
              >
                <a-select-option value="00">Pending</a-select-option>
                <a-select-option value="01">No Action Needed</a-select-option>
                <a-select-option value="02">Pending Refund</a-select-option>
                <a-select-option value="03">Refunding</a-select-option>
                <a-select-option value="04">Pending Reduction</a-select-option>
                <a-select-option value="05">Processed</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="7">
            <a-button type="primary" @click="updateStatusBatch" icon="search">Save</a-button>
          </a-col>

        </a-row>
      </a-form>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        :row-selection="{ onChange: onSelectChange }"
        bordered>
        <template slot="status" slot-scope="text, record">
        <a-select
        v-model="record.status"

        @change="handleStatusChange(record)"
      >
        <a-select-option value="00">Pending</a-select-option>
        <a-select-option value="01">No Action Needed</a-select-option>
        <a-select-option value="02">Pending Refund</a-select-option>
        <a-select-option value="03">Refunding</a-select-option>
        <a-select-option value="04">Pending Reduction</a-select-option>
        <a-select-option value="05">Processed</a-select-option>
      </a-select>
    </template>
        <span slot="action" slot-scope="text, record">
          <a @click="updateStatus(record)">
            Modify
          </a>
        </span>

      </a-table>
      <div style="margin-top: 15px; text-align: right;">
        <v-pagination
          v-if="total"
          :page-num="form.pageNum"
          :page-size="form.pageSize"
          :total="total"
          @change="handleTableChange" />
      </div>
      <v-repeat-repay-update-module ref="repeatRepayUpdateModule" @ok="modalFormOk" ></v-repeat-repay-update-module>
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import vFlowModule from './modules/CollectionAccountTradeFlowModule'
import vRepeatRepayUpdateModule from './modules/RepeatRepayUpdateModule'
import { repeatRepayFlowList, repeatRepayFlowUpdateBatch } from '@/webpublicapi/CollectionAccountInfo'
import vModal from '@/views/webpublic/modules/Modal'
import moment from 'moment/moment'
import exportFile from '@/webpublicapi/exportFile'
import { repeatRepayFlowUpdate } from '@/webpublicapi/CollectionAccountInfo'
const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.'
}

export default {
  name: 'AllApprovalTask',
  components: {vModal, vFlowModule, vRepeatRepayUpdateModule },
  data () {
    return {
      I18N_KEY,
      // Pagination params
      form: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      allowClear: true,
      dataSource: [],
      // Query conditions
      queryParam: {
        dataDt: [moment(new Date).add(-10, 'days'), moment(new Date)],
        status: null
      },
      loading: false,
      visible1: false,
      visible2: false,
      flowInfo:{
        mobileNo:"",
        flowType: null
      },
      selectedRowKeys: [],
      saveStatus: null
    }
  },
  computed: {
    columns () {
      return [
        {
          title: "Order No.",
          align: 'left',
          dataIndex: 'orderNo'
        },
        {
          title: "Single Period Min Period",
          align: 'left',
          dataIndex: 'installmentType',
          customRender: (text) => {
            if (text === "0") {
              return 'Single Period'
            } else if (text === "1") {
              return 'Min Period'
            }
          }
        },
        {
          title: "RepaymentSingleNo.",
          align: 'left',
          dataIndex: 'payinId'
        },
        {
          title: "Amount",
          align: 'left',
          dataIndex: 'amount'
        },
        {
          title: "RepaymentType",
          align: 'left',
          dataIndex: 'payType',
          customRender: (text) => {
            if (text === "00" || text === "09") {
              return 'Full'
            } else if (text === "01" || text === "10") {
              return 'Extension'
            } else if (text === "03" || text === "07") {
              return 'Full'
            } else if (text === "0304" || text === "08") {
              return 'Extension'
            } else {
              return 'Other:' + text
            }
          }
        },
        {
          title: "Order Status",
          align: 'left',
          dataIndex: 'orderSettleStatus',
          customRender: (text) => {
            if (text === "0") {
              return 'Unsettled'
            } else if (text === "1") {
              return 'Early Settlement'
            } else if (text === "3") {
              return 'OverdueSettled'
            } else if (text === "4") {
              return 'Extension Settlement'
            } else if (text === "5") {
              return 'OverdueExtension Settlement'
            } else if (text === "2") {
              return 'NormalSettled'
            } else {
              return 'Other:' + text
            }
          }
        },
        {
          title: "Status",
          align: 'left',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: "RepaymentChannel",
          align: 'left',
          dataIndex: 'channel'
        },
        {
          title: "Due Date",
          align: 'left',
          dataIndex: 'endDate'
        },
        {
          title: "Repayment Time",
          align: 'left',
          dataIndex: 'flowUpdatedTime'
        },
        {
          title: "Batch No.",
          align: 'left',
          dataIndex: 'appSsid'
        },
        {
          title: 'Action',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
  },
  created () {
    this.loadData(1);
  },
  methods: {
    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    handleStatusChange(records){
      this.loading = true
      repeatRepayFlowUpdate(records).then(res=>{
        if(res.code===1000){
        }else{
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },
    updateStatusBatch() {
      this.loading = true
      var updateParam = {
        ids: this.selectedRowKeys,
        status: this.saveStatus
      }

      repeatRepayFlowUpdateBatch(updateParam).then(res=>{
        if(res.code===1000){
          this.loadData();
        }else{
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },
    searchQuery () {
      this.loadData(1)
    },
    updateStatus(record) {
      this.$refs.repeatRepayUpdateModule.edit(record);
      this.$refs.repeatRepayUpdateModule.title = 'EditStatus';
    },
    modalFormOk () {
      this.loadData();
    },
    loadData (arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      repeatRepayFlowList(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.total = res.data.total
          this.dataSource = res.data.rows
        }else{
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },

    getQueryParams () {
      var dataDt = this.queryParam.dataDt;
      const data = {
        ...this.queryParam,
        beginCreateTime: dataDt && this.transformTime(dataDt[0]),
        endCreateTime: dataDt && this.transformTime(dataDt[1]),
      }
      delete data.dataDt;

      var param = Object.assign({}, data)
      param.pageNum = this.form.pageNum;
      param.pageSize = this.form.pageSize;
      return filterObj(param)
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    handleTableChange (pageNum, pageSize) {
      this.form.pageNum = pageNum;
      this.form.pageSize = pageSize;
      this.loadData();
    },
    downLoadData() {
      var params = this.getQueryParams()// Query conditions
      var beginTime = params.beginCreateTime;
      var status = params.status;
      var orderNo = params.orderNo;
      if (!beginTime) {
        alert('PleaseSelect date');
        return false;
      }
      var url = '/api/web/webpublic/repeatRepayFlow/exportNeedRefund?beginCreateTime='
        + params.beginCreateTime + '&endCreateTime='
        + params.endCreateTime;
      if (status) {
        url = url + '&status=' + status;
      }
      if (orderNo) {
        url = url + '&orderNo=' + orderNo;
      }
      const file = {
        fileUrl: url,
        fileName: params.beginCreateTime + '&' + params.endCreateTime + '&02.xlsx',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "~@/assets/less/common.less";
.description {
  line-height: 1.4;
  &.d_text {
    text-indent: 1em;
  }
  &.d_high_light {
    color: #fd9a38;
  }
}
</style>
